import axios from 'axios';
import { beginCheckoutSession } from './orderSuccessSnapshot';

/**
 * Build checkout payload for a single wishlist / product line (same shape as cart placeOrder).
 */
export function buildCheckoutDraftFromWishlistItem(item, { selectedSize, selectedQty = 1 }) {
    const product_id = item.product_id || item._id;
    const title = item.title || item.product_title || 'Product';
    const urls = item.urls || (item.image ? [item.image] : []);
    const price = Number(item.price) || 0;
    const mrp = Number(item.mrp) || price;
    const qty = Math.max(1, Number(selectedQty) || 1);

    const orderItem = {
        product_id,
        selectedSize,
        selectedQty: qty,
        unit_price: price,
        unit_mrp: mrp,
        total_price: price * qty,
        total_mrp: mrp * qty,
        discount_amount: (mrp - price) * qty,
        product_title: title,
        product_data: { title, urls: urls || [] },
    };

    return {
        order_items: [orderItem],
        order_summary: {
            item_count: qty,
            total_mrp: mrp * qty,
            total_discount: (mrp - price) * qty,
            coupon_discount: 0,
            shipping_fee: 0,
            final_amount: price * qty,
        },
        coupon_code: '',
        use_store_credit: false,
    };
}

/**
 * Persist checkout draft before navigating to order-summary (wishlist Buy Now).
 */
export async function saveCheckoutDraftForBuyNow(item, { selectedSize, selectedQty = 1 }) {
    const isGuest = localStorage.getItem('guestUser') === 'true';
    const draft = buildCheckoutDraftFromWishlistItem(item, { selectedSize, selectedQty });

    beginCheckoutSession();

    if (isGuest) {
        localStorage.setItem(
            'guestCheckoutData',
            JSON.stringify({ ...draft, selectedCoupon: null })
        );
        return;
    }

    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('Please login to continue');
    }

    const response = await axios.post('/orders/create', draft, {
        headers: { Authorization: `Bearer ${token}` },
    });

    if (response.data?.order) {
        localStorage.setItem(
            'latestOrder',
            JSON.stringify({
                ...response.data.order,
                order_items: draft.order_items,
            })
        );
    } else {
        localStorage.setItem('latestOrder', JSON.stringify(draft));
    }
}
